export const gtmAction = (event: string, more?: Record<string, string>) => {
  if (typeof window?.dataLayer?.push !== 'undefined') {
    window.dataLayer.push({
      event,
      ...more,
    });
  }
}
